import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const POST_FUNKPROTOKOLL_VORLAGE_ANLEGEN_ADMIN = '[VeranstaltungenModul] PostFunkprotokollVorlageAnlegenAdmin laden';
export const POST_FUNKPROTOKOLL_VORLAGE_ANLEGEN_ADMIN_AUSFUEHREN = '[VeranstaltungenModul] PostFunkprotokollVorlageAnlegenAdmin ausführen';
export const POST_FUNKPROTOKOLL_VORLAGE_ANLEGEN_ADMIN_ERFOLGREICH = '[VeranstaltungenModul] PostFunkprotokollVorlageAnlegenAdmin laden erfolgreich';
export const POST_FUNKPROTOKOLL_VORLAGE_ANLEGEN_ADMIN_FEHLER = '[VeranstaltungenModul] PostFunkprotokollVorlageAnlegenAdmin Ladefehler';
export const POST_FUNKPROTOKOLL_VORLAGE_ANLEGEN_ADMIN_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] PostFunkprotokollVorlageAnlegenAdmin nicht ausgeführt (evtl. Offline)';


export class PostFunkprotokollVorlageAnlegenAdminAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_ANLEGEN_ADMIN;
        constructor(public funkprotokollVorlageDatenRequest: api.FunkprotokollVorlageDatenRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollVorlageAnlegenAdminAusfuehrenAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_ANLEGEN_ADMIN_AUSFUEHREN;
        constructor(public funkprotokollVorlageDatenRequest: api.FunkprotokollVorlageDatenRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollVorlageAnlegenAdminErfolgreichAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_ANLEGEN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.FunkprotokollVorlageIdentifier, public funkprotokollVorlageDatenRequest: api.FunkprotokollVorlageDatenRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollVorlageAnlegenAdminFehlerAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_ANLEGEN_ADMIN_FEHLER;
        constructor(public payload: any, public funkprotokollVorlageDatenRequest: api.FunkprotokollVorlageDatenRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollVorlageAnlegenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_ANLEGEN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenCommandFunkprotokollVorlageAnlegenAdminActions =
    PostFunkprotokollVorlageAnlegenAdminAction
    | PostFunkprotokollVorlageAnlegenAdminAusfuehrenAction
    | PostFunkprotokollVorlageAnlegenAdminErfolgreichAction
    | PostFunkprotokollVorlageAnlegenAdminFehlerAction
    | PostFunkprotokollVorlageAnlegenAdminNichtAusgefuehrtAction
    ;
